import { useNavigate } from 'react-router-dom';
import { Button } from '@aws-amplify/ui-react';
import { Agent } from '@heartcheck/shared';

export function ConfigurationAgentItem(props: { agent: Agent }) {
  const nav = useNavigate();

  const onClick = () => {
    nav(`/configuration/agent/${props.agent.id}`);
  };

  return (
    <Button
      onClick={onClick}
      isFullWidth
      variation="link"
      justifyContent="start"
      className="text-left text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 px-4 py-2 rounded-md"
    >
      {props.agent.name}
    </Button>
  );
}
